import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import template from './admin-app.hbs'
import referToRowTemplate from './refer-to-row.hbs'
import AdminCurrencies from './admin-currencies'
import i18n from 'scoreboard/components/i18n'
import formHelper from 'scoreboard/components/form-helper'
import FormView from 'scoreboard/components/form-view'
import config from 'scoreboard/components/config'
import MarkedField from 'scoreboard/components/marked-field'
import emailValidator from 'scoreboard/components/validators/email-validator'
import numericEvaluator from 'scoreboard/components/evaluators/numeric-evaluator'
import numericValidator from 'scoreboard/components/validators/numeric-validator'
import requiredValidator from 'scoreboard/components/validators/required-validator'
import positiveIntegerValidator from 'scoreboard/components/validators/positive-integer-validator'
import appDisplay from 'scoreboard/components/app-display'
import license from 'scoreboard/components/license'
import DisplayHeader from 'scoreboard/components/display-header'
import selects from 'scoreboard/components/selects'
import calendars from 'scoreboard/components/calendars'
import dropdown from 'scoreboard/components/dropdown'
import EmptyState from 'scoreboard/components/empty-state'
import noPermission from 'scoreboard/components/no-permission.hbs'
import permissions from 'scoreboard/components/permissions'
import LdapServers from './ldap-servers-model'
import LdapServersView from './admin-ldap-servers'
import SinglePrincipalChooser from 'scoreboard/components/single-principal-chooser'
import projects from 'scoreboard/projects/projects'
import fileInfo from 'scoreboard/components/files/file-info'
import { renderTimeDisplayTypeSelect } from 'scoreboard/datasets/edit/fields/field-form'
import nonZeroPositiveIntegerValidator from 'scoreboard/components/validators/non-zero-positive-integer-validator'
import MultiPrincipalChooser from 'scoreboard/components/multi-principal-chooser'
import enums from 'scoreboard/components/enums'
import EditableButton from 'scoreboard/components/editable-button'
import OrgSelectionForm from 'scoreboard/components/org-selection-form'
import numericRangeValidatorFactory from 'scoreboard/components/validators/numeric-range-validator-factory'
import LabeledToggle from 'scoreboard/components/labeled-toggle'
import formatValue from 'scoreboard/components/format-value'
import TagsChooser from '../../components/tags-chooser'
import ConfirmPrompt from 'scoreboard/components/confirm-prompt'
import DataType from 'scoreboard/datasets/model/data-type'
import fileDrop from 'scoreboard/components/files/file-drop.hbs'
import FileDropOverlay from 'scoreboard/components/files/file-drop-overlay'
const { NUMBER, PERCENT } = DataType
import highlight from 'scoreboard/components/highlight'
import { SCORE } from 'scoreboard/components/format-value'
import constants from 'scoreboard/components/constants'
const { APP_CERTIFICATE_PEM, APP_CERTIFICATE_PRIVATE_KEY_PEM } = constants
import fileAttachment from 'scoreboard/components/files/file-attachment.hbs'
import fileAttachmentContent from 'scoreboard/components/files/file-attachment-content.hbs'
import pemFileValidator from 'scoreboard/components/validators/pem-file-validator'
import ErrorView from '../../components/error-view'
import CalendarRangeSelector from 'scoreboard/components/calendar-range-selector'
import configurableTerminologyValidator
	from './configurable-terminology-validator'
import fileExtensionValidatorFactory from 'scoreboard/components/validators/file-extension-validator-factory'
import { getBrowserLanguage, getAllLanguages } from './language'

const markNumericOptions = () => ({
	evaluator: numericEvaluator,
	validators: [numericValidator],
	dataType: NUMBER
})

function markNumericField(el, markerContent, required) {
	const options = _.extend({}, markNumericOptions(), { el, markerContent })
	if (required) {
		options.validators.push(requiredValidator)
	}
	return new MarkedField(options).render()
}

function markPositiveIntegerField(el, markerContent) {
	return new MarkedField({
		el: el,
		evaluator: numericEvaluator,
		validator: positiveIntegerValidator,
		markerContent
	}).render()
}

function markNonZeroPositiveIntegerField(el, markerContent) {
	return new MarkedField({
		el: el,
		evaluator: numericEvaluator,
		validator: nonZeroPositiveIntegerValidator,
		markerContent
	}).render()
}

const markPercentOptions = () => ({
	evaluator: numericEvaluator,
	validators: [numericValidator, positiveIntegerValidator],
	dataType: PERCENT
})

function markPercentField(el) {
	const options = _.extend({}, markPercentOptions(), { el })
	return new MarkedField(options).render()
}

function getAllowedNonMetricScoringTypes() {
	let types = [ 'two-color', 'three-color', 'four-color-orange',
		'four-color-blue' ]
	let st = config.scoringType(config.nonMetricScoringTypeId)
	// #50914 'scored-middle-4-color' is no longer valid
	if (st.standardScoringType === 'scored-middle-4-color') {
		types.push('scored-middle-4-color')
	}
	return types
}

// cache of potential members.  keep it outside individual ExportForm instances.
// Note this is cleared out in the remove method of the view so navigating to a
// new screen always clears the cache
let potentialPrincipals

const scoreToPercent = value => value && value * 10
const percentToScore = value => value && value / 10

/**
 * @class AdminApp
 * @augments Backbone.View
 */
var AdminApp = Backbone.View.extend({

	tagName: 'form',

	className: 'admin table-hack display-layout admin-app',

	events: {
		'click .cancel': 'cancel',
		'click .set-organization': 'renderReplicationDestinationForm',
		'click .set-file': 'renderReplicationDestinationForm',
		'click .open-currencies': 'currencies',
		'change [name=oidcLookupUserBy]': '_onChangeOidcLookupUserBy',
		'change [name=sessionTimeoutInterval]': 'onChangeSessionTimeoutInterval',
		'change [name=minimumScore]': 'onChangeMinOrMaxScore',
		'change [name=maximumScore]': 'onChangeMinOrMaxScore',
		'change [name=language]': 'onChangeLanguage',
		'click .reset.app-cert-uploaded-reset': 'onResetAppCert',
		'click .reset.app-cert-private-key-uploaded-reset': 'onResetAppCertPrivateKey',
		'dragenter': 'onDragEnter',
		'click .file-drop': 'onClickFileDrop',
		'click .delete-logo-button': 'onClickDeleteLogoButton'
	},

	initialize: function(options) {
		this.options = _.cloneDeep(options)
		this.config = options.config
		this.ldapServers = new LdapServers(options.ldapServers)
		this.referToByLanguage = options.referToByLanguage
		this._lastSavedData = {
			config: options.config,
			ldapServers: options.ldapServers,
			referToByLanguage: options.referToByLanguage,
			accountChangeAlertUsers: options.accountChangeAlertUsers
		}
		this.selectedAlertUsers = options.accountChangeAlertUsers
		this.defaultAlertEmail = options.defaultAlertEmail
		this.replicationSettings = {}
		this.globalTags = options?.globalTags

		this.localConfig = {
			customLogoId: options.config.customLogoId
		}

		this.formView = new FormView({
			el: this.el,
			toggleCancel: true,
			test: this.test.bind(this),
			submit: this.submit.bind(this)
		})
	},

	render: function() {
		// #20029 either appAdmin or serverAdmin permission is required for Application Administration
		if (!permissions.serverAdmin() && !permissions.appAdmin()) {
			this.$el.empty().append(new EmptyState({
				body: noPermission()
			}).render().el)
			return this
		}

		this.$el.empty().append(new DisplayHeader({
			heading: i18n.get('admin.group.abilities.applicationConfigure'),
			mobileGearHidden: true
		}).render().el, template({ license, config, defaultAlertEmail: this.defaultAlertEmail }))

		this.secure()

		// If SMS, add a CAC option
		if (this.config.smartCardLoginAllowed) {
			var code = 'admin.authentication.type.smartcard'
			var label = i18n.get(code)
			this.$('[name=authenticationType]').append(new Option(label, 'smart-card'))
		}

		// render all the yes-no dropdowns at once
		this.$('.yes-no').append(new Option(i18n.get('common.yes'), 'true'))
		this.$('.yes-no').append(new Option(i18n.get('common.no'), 'false'))

		// render scoring type dropdown
		let scoringTypes = _.filter(config.scoringTypes, st =>
			_.includes(getAllowedNonMetricScoringTypes(), st.standardScoringType) ||
			st.kpiValueType == 'number')
		dropdown.scoringType(this.$('[name=nonMetricScoringTypeId]'),
			config.nonMetricScoringTypeId, { scoringTypes })

		// render default calendar period dropdown
		var calendarSelect = this.$('[name=defaultPeriod]')
		_.forEach(['previous', 'current'], function(period) {
			var code = 'admin.appConfiguration.generalSettings.defaultCalendarPeriod.' + period
			var label = i18n.get(code)
			calendarSelect.append(new Option(label, period))
		})

		// render ytdCalendarId dropdown
		dropdown.idLabels(this.$('[name=ytdCalendarId]'), calendars.calendars)
		// render defaultCurrencyCode dropdown
		this.renderCurrencies()

		this.renderPublicReadOnlyUserIdChooser()

		this.renderDefaultTimeDisplayType()

		this.renderReplicationFileStorageTypeSelects()

		this.renderReplicationEditableButtons()

		this.renderShowScoresAsToggle()

		// #59140 calling this before validating inputs helps in
		// properly rendering percentages
		this.writeToDom()

		// wrap fields
		this._markedFields = []

		// validate positive integer inputs
		_.each(this.$('input.positive-integer[type=text], input.numeric[type=text]'), function(input) {
			let markerContent = this.$(input).data('marker-content')
			if (markerContent) {
				// Add proper capitalization for consistency
				markerContent = _.upperFirst(markerContent)
			}
			if (this.$(input).hasClass('non-zero')) {
				this._markedFields.push(markNonZeroPositiveIntegerField(input, markerContent))
			} else if (this.$(input).hasClass('positive-integer')) {
				this._markedFields.push(markPositiveIntegerField(input, markerContent))
			} else {
				// #45223 add required validator to minimumScore and maximumScore
				let required = this.$(input).hasClass('required')
				this._markedFields.push(markNumericField(input, markerContent, required))
			}
		}.bind(this))

		// validate percent inputs
		_.each(this.$('input.percent[type=text]'), function(input) {
			this._markedFields.push(markPercentField(input))
		}.bind(this))

		this._markedFields.push(new MarkedField({
			el: this.$('[name=supportEmail]'),
			validator: emailValidator
		}).render())

		this._markedFields.push(new MarkedField({
			el: this.$('[name=alertEmailAddress]'),
			validator: emailValidator
		}).render())

		this._markedFields.push(new MarkedField({
			el: this.$('[name=enableProjects]'),
			validator: enabled => {
				if ('false' === enabled && !projects.single()) {
					return i18n.get('common.project.warning.disable')
				}
			}
		}).render())

		this._markedFields.push(new MarkedField({
			el: this.$('[name=defaultCurrencyCode]'),
			validator: requiredValidator
		}).render())

		this.markRequiredIf('oidcClaimProperty', () => this.authType() === 'open-id')
		this.markRequiredIf('samlMetadata', () => this.authType() === 'saml')

		// #25035 render multiple selects after formHelper.writeToDom
		// so it doesn't overwrite multiple selections with only the first one
		this._renderMetricUpdateReminders()
		this._renderTagChoosers()
		this.renderAllowedFileTypes()
		this.renderAuthenticationSelects()
		this._updateScoresOutsideMinMaxLabel()
		this._addScoreMinMaxRangeValidators()
		this.renderMethodologyDropdowns()
		this.renderFileDrop()
		this.renderFileDropOverlay()

		;['showWelcomeMessage', 'enableProjects'].forEach(key => {
			if (_.isNil(this.config[key])) {
				this.$(`[name=${key}]`).val('false').prop('selected', true)
			}
		})

		this.formView.start()

		const specialSetupSelects = [
			'.public-read-only-user-select',
			'.allowed-file-types',
			'.alert-days-overdue-metrics',
			'.time-display-type',
			'.special-setup',
			'[name^=referTo]'
		].join(', ')
		selects(this.$(`select:not(${specialSetupSelects})`))

		this._ldapServersView = new LdapServersView({ model: this.ldapServers })
		this.$('.authentication .panel-content').append(this._ldapServersView.el)
		this._ldapServersView.render()

		this.listenTo(this.ldapServers, 'change add remove', this.formView.setDirty.bind(this.formView))

		this._updateAuthSectionVisibility()
		this.updateCertSendWithRESTImportsVisibility()
		this._updatePasswordSettingsVisibility()
		this.$('[name=authenticationType]').change(this._onAuthTypeChange.bind(this))

		this._renderPrincipalChooser()

		this.onChangeReplicationFileStorageTypeSelects()

		this.toggleMinMaxScore()

		this.renderImpactIcon()
		this.renderDeleteLogoButton()
		this.renderChartRangeSelector()

		// #49720 marked fields for fields that represent score values
		// (redMetricIndicatorScore, requireNoteScore)
		_.each(this.$('input.score[type=text]'), input => {
			this.markScoreField(input)
		})

		return this
	},

	markRequiredIf (inputName, predicate) {
		this._markedFields.push(new MarkedField({
			el: this.$(`[name=${inputName}]`),
			validator: value => {
				if (predicate) {
					return requiredValidator(value)
				}
			}
		}).render())
	},

	/**
	 * #49720 adds marked fields for score field inputs
	 * (redMetricIndicatorScore, requireNoteScore)
	 */
	markScoreField: function(input) {
		let inputName = input.name
		let markedField = this._findMarkedFieldByInputName(inputName)
		let scoreOpts = this._scoreFieldMarkingOptions(input)
		if (!_.isNil(markedField)) {
			// if marked field already exists, update it with the correct
			// scoring options
			markedField.mark(scoreOpts)
		} else {
			// or add it, if it doesn't already exist
			markedField = new MarkedField(scoreOpts)
			this._markedFields.push(markedField.render())
		}
	},

	/**
	 * returns the correct options for creating a marked field for a field
	 * field that represents a score value, based on the current selection of
	 * "Show Scores as"
	 */
	_scoreFieldMarkingOptions: function(input) {
		let markerContent, dataType
		if (this._getShowScoresAsPercent()) {
			dataType = PERCENT
			markerContent = '%'
		} else {
			dataType = NUMBER
			markerContent = this.$(input).data('marker-content')
			if (markerContent) {
				// Add proper capitalization for consistency
				markerContent = _.upperFirst(markerContent)
			}
		}
		return {
			el: input,
			dataType,
			evaluator: numericEvaluator,
			validators: [numericValidator],
			markerContent
		}
	},

	_findMarkedFieldByInputName(name) {
		return this._markedFields.find(it => {
			const el = _.get(it, 'options.el', {})
			if (el.length) return el[0].name === name

			return el.name === name
		})
	},

	_renderPrincipalChooser() {
		const selected = this.selectedAlertUsers.map(u => _.extend({ type: 'user' }, u))
		this.principalChooser = new MultiPrincipalChooser({
			el: this.$('.recipient-chooser'),
			cache: potentialPrincipals,
			currentPrincipals: selected,
			multiple: true,
			autofocus: false,
			exclude: 'group'
		}).render()
		this.principalChooser.on('load', data => {
			potentialPrincipals = data
		})
		this.principalChooser.show({open: false})
	},

	renderShowScoresAsToggle() {
		this.showScoresAsToggle = new LabeledToggle({
			name: 'showScoresAs',
			options: [{
				value: NUMBER,
				label: i18n.get('scorecards.node.metric.dataType.number')
			}, {
				value: PERCENT,
				label: i18n.get('scorecards.node.metric.dataType.percentage')
			}]
		})
		this.$('.show-scores-as').append(this.showScoresAsToggle.el)
		this.showScoresAsToggle.render()
		this.showScoresAsToggle.on('change', this.onChangeShowScoresAsToggle.bind(this))
	},

	renderPublicReadOnlyUserIdChooser() {
		this.publicReadOnlyUserIdChooser = new SinglePrincipalChooser({
			el: this.$('.public-read-only-user'),
			selected: config.publicReadOnlyUser
		}).render()
	},

	renderDefaultTimeDisplayType() {
		renderTimeDisplayTypeSelect(
			this.$('[name=defaultTimeDisplayType]'),
			config.defaultTimeDisplayType
		)
	},

	renderAuthenticationSelects() {
		if (_.isNil(this.config.maxInvalidLoginAttempts)) {
			this.$('[name=maxInvalidLoginAttempts] option')
				.first()
				.prop('selected', true)
				.trigger('change')
		}

		if (_.isNil(this.config.passwordReuseInterval)) {
			this.$('[name=passwordReuseInterval] option')
				.first()
				.prop('selected', true)
				.trigger('change')
		}

		if (_.isNil(this.config.oidcClaimProperty)) {
			this._onChangeOidcLookupUserBy()
		}
	},

	renderAllowedFileTypes() {
		let selections = _.get(this.config, 'allowedFileTypes', [])
		let options = _(fileInfo.extensions)
			.keys()
			.without('spreadsheetWithoutNumbers', 'csv', 'spreadsheetOrZip',
				'logoImage', 'excel')
			.map(type => {
				return {
					value: type,
					label: i18n.get('documents.fileType.' + type),
					selected: _.includes(selections, type)
				}
			})
			.value()

		selects.filtering(this.$('[name=allowedFileTypes]'), {
			multiple: true,
			options,
			placeholder: i18n.get('admin.appConfiguration.generalSettings.allowedFileTypes.placeholder')
		})
	},

	/**
	 * Renders all the dropdowns for the re-referencing options in the methodology panel
	 * Utilizes the helper function renderMethodologyDropdown, see function for more
	 *
	 * Author: Jack Huffman
	 * Date: 6/20/2024
	 */
	renderMethodologyDropdowns () {
		// Render the dropdown of supported languages
		dropdown.idLabels(this.$('[name=language]'),
			enums.toOptionData('language'),
			getBrowserLanguage())

		getAllLanguages().forEach(language => {
			this.renderLocalizedMethodologyDropdowns(language)
		})

		this.toggleMethodologyDropdownVisibility()
	},

	onChangeLanguage () {
		this.toggleMethodologyDropdownVisibility()
	},

	toggleMethodologyDropdownVisibility () {
		let language = this.$('[name=language]').val()
		this.$('[data-language]').each((index, el) => {
			let row = $(el)
			let rowLanguage = row.attr('data-language')
			row.toggleClass('is-not-displayed', rowLanguage !== language)
		})
	},

	/**
	 * Renders all the methodology dropdowns for the given language
	 * @param {Language} language
	 */
	renderLocalizedMethodologyDropdowns (language) {
		// Render each row of methodology term inputs for the given language
		METHODOLOGY_OBJECT_TYPES.forEach(type => {
			let capitalizedType = type.charAt(0).toUpperCase() + type.substring(1)
			let messagePrefix = 'admin.appConfiguration.methodology.'
			let singular = `referTo${capitalizedType}`
			let plural = `referTo${capitalizedType}s`
			this.$('.refer-to-panel').append(referToRowTemplate({
				iconId: METHODOLOGY_ICON_OVERRIDES[type] ?? type,
				singular,
				plural,
				singularMessageCode: messagePrefix + singular,
				pluralMessageCode: messagePrefix + plural,
				language
			}))
		})

		// Render the 'Refer To Perspective As' dropdown
		this.renderMethodologyDropdown(
			'referToPerspectiveAs',
			[
				'admin.appConfiguration.methodology.perspective',
				'admin.appConfiguration.methodology.keyPerformanceArea'
			],
			'admin.appConfiguration.methodology.perspective',
			language
		)

		// Render the 'Refer To Perspectives As' dropdown
		this.renderMethodologyDropdown(
			'referToPerspectivesAs',
			[
				'admin.appConfiguration.methodology.perspectives',
				'admin.appConfiguration.methodology.keyPerformanceAreas'
			],
			'admin.appConfiguration.methodology.perspectives',
			language
		)

		// Render the 'Refer To Objective As' dropdown
		this.renderMethodologyDropdown(
			'referToObjectiveAs',
			[
				'admin.appConfiguration.methodology.objective'
			],
			'admin.appConfiguration.methodology.objective',
			language
		)

		// Render the 'Refer To Objectives As' dropdown
		this.renderMethodologyDropdown(
			'referToObjectivesAs',
			[
				'admin.appConfiguration.methodology.objectives'
			],
			'admin.appConfiguration.methodology.objectives',
			language
		)

		// Render the 'Refer To Generic Item As' dropdown
		this.renderMethodologyDropdown(
			'referToGenericItemAs',
			[
				'admin.appConfiguration.methodology.genericItem',
				'admin.appConfiguration.methodology.theme'
			],
			'admin.appConfiguration.methodology.theme',
			language
		)

		// Render the 'Refer To Generic Items As' dropdown
		this.renderMethodologyDropdown(
			'referToGenericItemsAs',
			[
				'admin.appConfiguration.methodology.genericItems',
				'admin.appConfiguration.methodology.themes'
			],
			'admin.appConfiguration.methodology.themes',
			language
		)

		// Render the 'Refer To KPI As' dropdown
		this.renderMethodologyDropdown(
			'referToKpiAs',
			[
				'admin.appConfiguration.methodology.KPI',
				'admin.appConfiguration.methodology.metric',
				'admin.appConfiguration.methodology.measure'
			],
			'admin.appConfiguration.methodology.measure',
			language
		)

		// Render the 'Refer To KPIs As' dropdown
		this.renderMethodologyDropdown(
			'referToKpisAs',
			[
				'admin.appConfiguration.methodology.KPIs',
				'admin.appConfiguration.methodology.metrics',
				'admin.appConfiguration.methodology.measures'
			],
			'admin.appConfiguration.methodology.measures',
			language
		)

		// Render the 'Refer To Initiative As' dropdown
		this.renderMethodologyDropdown(
			'referToInitiativeAs',
			[
				'admin.appConfiguration.methodology.initiative',
				'admin.appConfiguration.methodology.project',
				'admin.appConfiguration.methodology.actionPlan'
			],
			'admin.appConfiguration.methodology.initiative',
			language
		)

		// Render the 'Refer To Initiatives As' dropdown
		this.renderMethodologyDropdown(
			'referToInitiativesAs',
			[
				'admin.appConfiguration.methodology.initiatives',
				'admin.appConfiguration.methodology.projects',
				'admin.appConfiguration.methodology.actionPlans'
			],
			'admin.appConfiguration.methodology.initiatives',
			language
		)

		// Render the 'Refer To Task As' dropdown
		this.renderMethodologyDropdown(
			'referToTaskAs',
			[
				'admin.appConfiguration.methodology.task',
				'admin.appConfiguration.methodology.action'
			],
			'admin.appConfiguration.methodology.task',
			language
		)

		// Render the 'Refer To Tasks As' dropdown
		this.renderMethodologyDropdown(
			'referToTasksAs',
			[
				'admin.appConfiguration.methodology.tasks',
				'admin.appConfiguration.methodology.actions'
			],
			'admin.appConfiguration.methodology.tasks',
			language
		)

		// Render the 'Refer To Milestone As' dropdown
		this.renderMethodologyDropdown(
			'referToMilestoneAs',
			[
				'admin.appConfiguration.methodology.milestone'
			],
			'admin.appConfiguration.methodology.milestone',
			language
		)

		// Render the 'Refer To Milestones As' dropdown
		this.renderMethodologyDropdown(
			'referToMilestonesAs',
			[
				'admin.appConfiguration.methodology.milestones'
			],
			'admin.appConfiguration.methodology.milestones',
			language
		)
	},

	/**
	 * Renders a dynamic dropdown for selecting methodology items, supporting predefined options
	 * and allowing for custom user input. The function populates the dropdown with given options,
	 * ensures the currently selected value from the config is highlighted, and adds it to the list
	 * if it is not already included.

	 * @param {string} name - The name attribute of the select element, which is also used to
	 *                        retrieve the current value from the config.
	 * @param {string[]} optionsList - An array of i18n keys which represent various pre-defined
	 * 								referencing options for users to select from
	 * @param {string} placeholderKey - The i18n key for the placeholder text in the dropdown
	 *
	 * @param {Language} language - the language that this methodology term will apply to
	 *
	 * Author: Jack Huffman
	 * Date: 6/20/2024
	 */
	renderMethodologyDropdown: function(name, optionsList, placeholderKey, language) {
		// Get current value from the config
		let currentValue = this.referToByLanguage[language]?.[name]
		let inputName = `${name}\\.${language}`

		// Generate options array with predefined values
		let options = optionsList.map(option => ({
			label: i18n.get(option),
			value: i18n.get(option),
			selected: currentValue === i18n.get(option)
		}))

		// Handle case to render a user inputted option
		if (!options.some(option => option.value === currentValue)) {
			options.push({ label: currentValue, value: currentValue, selected: true })
		}

		// Use the filtering function for the select element
		selects.filtering(this.$(`[name=${inputName}]`), {
			multiple: false,
			options,
			render: {
				create: function (d) {
					return i18n.get('common.add2', d.label)
				}
			},
			placeholder: i18n.get(placeholderKey)
		})

		this._markedFields.push(new MarkedField({
			el: this.$(`[name=${inputName}]`),
			validator: configurableTerminologyValidator
		}).render())
	},

	renderImpactIcon() {
		const customLogoId = parseInt(this.localConfig.customLogoId)
		const logoUrl = Number.isNaN(customLogoId)
			? '../resources/images3/spider-impact-square.svg'
			: `../api/images/${customLogoId}`
		this.updateImage(logoUrl)
	},

	renderDeleteLogoButton: function() {
		const hasCustomLogo = this.localConfig.customLogoId != null
		const deleteButton = this.$('.delete-logo-button')

		deleteButton.toggleClass('is-not-displayed', !hasCustomLogo)
	},

	renderFileDrop: function() {
		this.$('.file-drop').append(fileDrop({
			noDropMessage: window.FormData ? null : i18n.get('documents.upload.noDrop'),
			dropLabel: i18n.get('admin.appConfiguration.appearance.dropLogoInstructions'),
			dropSubLabel: i18n.get('admin.appConfiguration.appearance.dropLogoSubInstructions'),
			iconId: 'icon-upload'
		}))
	},

	renderFileDropOverlay: function() {
		this.fileDropOverlay = new FileDropOverlay({
			message: i18n.get('admin.appConfiguration.appearance.dropLogoInstructions'),
			uploadIcon: 'icon-upload-file'
		})
		this.$el.append(this.fileDropOverlay.el)
		this.fileDropOverlay.render()
		this.fileDropOverlay.on('drop', e => this.onFileDrop(e))
	},

	onDragEnter: function(e) {
		e.preventDefault()
		this.fileDropOverlay.show()
	},

	onClickFileDrop: function() {
		// #59845 allow only image files without SVG or bmp
		let accept = fileInfo.accepts['logoImage']
		const fileInput = $(`<input type="file" accept="${accept}" style="display: none;">`)
		this.$el.append(fileInput)

		fileInput.on('change', (event) => {
			const file = event.target.files[0]
			if (file) {
				this.uploadImage(file)
			}
			fileInput.remove()
		})

		fileInput.click()
	},

	onFileDrop(e) {
		const file = e.originalEvent.dataTransfer?.files?.[0]
		// #59845 validate file extension before uploading
		let result = this.validateLogoExtension(file)
		if (_.isNil(result)) {
			this.uploadImage(file)
		} else {
			this.toggleLogoBannerError(result)
		}
	},

	/**
	 * Validates the logo file extension.  We allow image file types except SVG
	 * (#59845)
	 */
	validateLogoExtension: function (file) {
		let validator = fileExtensionValidatorFactory(['logoImage'])
		let result = validator(file.name)
		return result
	},

	onClickDeleteLogoButton: function(e) {
		e.preventDefault()
		this.unsavedLogoId = null
		this.localConfig.customLogoId = null
		this.renderImpactIcon()
		this.renderDeleteLogoButton()
		this.formView.setDirty()
	},

	checkImageDimensions: function(file) {
		return new Promise((resolve, reject) => {
			const img = new Image()
			img.onload = () => {
				const width = img.width
				const height = img.height
				const aspectRatio = width / height
				const minHeight = 0  // placeholder
				const maxHeight = 1000 // placeholder

				if (aspectRatio < 1) {
					let msg = i18n.get('admin.appConfiguration.appearance.logoUploadError.aspectRatio')
					this.toggleLogoBannerError(msg)
				} else if (height < minHeight || height > maxHeight) {
					let msg = i18n.get(
						'admin.appConfiguration.appearance.logoUploadError.dimensions',
						minHeight,
						maxHeight
					)
					this.toggleLogoBannerError(msg)
				} else {
					this.toggleLogoBannerError()
					resolve()
				}
			}
			img.onerror = () => reject('Failed to load image.')
			img.src = URL.createObjectURL(file)
		})
	},

	toggleLogoBannerError: function(msg) {
		this.$('.logo-container .banner-error')
			.toggleClass('is-not-displayed', _.isNil(msg))
			.text(msg)
	},

	updateImage(url) {
		this.$('.current-logo').css('background-image', `url("${url}")`)
	},

	showError(message) {
		appDisplay.dialog(new ErrorView(message))
	},

	uploadImage(file) {
		this.checkImageDimensions(file).then(() => {
			const reader = new FileReader()
			reader.onload = (e) => {
				const image = {
					name: file.name,
					dataUri: e.target.result
				}

				$.ajax({
					url: 'api/admin/custom-logo',
					type: 'POST',
					data: JSON.stringify(image),
					contentType: 'application/json',
					processData: false,
					success: (response) => {
						if (response?.customLogoId) {
							this.unsavedLogoId = parseInt(response.customLogoId)  // Store temporarily
							this.localConfig.customLogoId = this.unsavedLogoId
							this.updateImage(`../api/images/${response.customLogoId}`)
							this.formView.setDirty()
							this.renderDeleteLogoButton()
						} else {
							console.error('Unexpected response from server:', response)
						}
					},
					error: (xhr, status, error) => {
						console.error('Error uploading image:', error)
					}
				})
			}
			reader.readAsDataURL(file)
		})
	},

	deleteSavedLogo: function(logoId) {
		$.ajax({
			url: `api/admin/custom-logo-saved/${logoId}`,
			type: 'DELETE'
		})
	},

	deleteUnsavedLogo: function(logoId) {
		$.ajax({
			url: `api/admin/custom-logo/${logoId}`,
			type: 'DELETE'
		})
	},

	renderChartRangeSelector: function() {
		this.calendarRangeSelector = new CalendarRangeSelector({
			range: {
				calendarId: null, // Use current calendar
				relative: true,
				first: config.scorecardsChartStartPeriodDelta || -12,
				last: config.scorecardsChartEndPeriodDelta || 0
			},
			singlePeriod: false,
			allowAppCalendar: true,
			allowCurrentCalendar: true
		})

		let periodRangeSelectors = this.$('.period-range-selectors')
		periodRangeSelectors.html(this.calendarRangeSelector.el)
		this.calendarRangeSelector.render()

		// Fixes #59319
		if (periodRangeSelectors.length) {
			let relativeSelectors = periodRangeSelectors.find('.period-range .relative-selectors.toggler-row-content')
			if (relativeSelectors.length) {
				relativeSelectors.addClass('full-width side-by-boxes')
			}

			let firstLastSelectors = periodRangeSelectors.find('.first, .last')
			if (firstLastSelectors.length) {
				firstLastSelectors.addClass('wrapper-col')
			}
		}

		this.listenTo(this.calendarRangeSelector, 'change', this.onChartRangeSelectorChange)

	},

	onChartRangeSelectorChange: function(value) {
		config.scorecardsChartStartPeriodDelta = value.first
		config.scorecardsChartEndPeriodDelta = value.last
		this.formView.change()
	},

	onChangeSessionTimeoutInterval: function () {
		const input = this.$('[name=sessionTimeoutInterval]')
		const sessionTimeoutInterval = input.val()
		// #58990 #48502 if the session timeout interval is not set, this is a
		// valid value when clearing the input to have no timeout;
		// do not modify the value
		if (!sessionTimeoutInterval) {
			return
		}
		const max = constants.MAX_SESSION_TIMEOUT_INTERVAL_MINUTES
		const min = constants.MIN_SESSION_TIMEOUT_INTERVAL_MINUTES
		if (sessionTimeoutInterval > max) {
			input.val(max)
		} else if (sessionTimeoutInterval < min) {
			input.val(min)
		}
	},

	onChangeShowScoresAsToggle: function() {
		this.toggleMinMaxScore()

		// default numeric scores to start at 0 and go to 10
		if (this.showScoresAsToggle.val() == 'number') {
			this.$('[name=minimumScore]').val(0)
			this.$('[name=maximumScore]').val(10)
		}

		this._updateScoresOutsideMinMaxLabel()
		this._updateScoreFields(false)
		this.formView.change()
	},

	/**
	 * Toggles the display of the min/max score based on the selection of the
	 * "Show Scores As" toggle
	 */
	toggleMinMaxScore: function() {
		this.$('.min-max-score').toggleClass('is-not-displayed',
			this.showScoresAsToggle.val() == PERCENT)
	},

	onChangeMinOrMaxScore: function() {
		this._updateScoresOutsideMinMaxLabel()
	},

	_updateScoresOutsideMinMaxLabel: function() {
		let [min, max] = this._getFormattedMinMaxScores()
		this.$('.allow-scores-outside-min .label-text').text(i18n.get(
			'admin.appConfiguration.scoring.allowScoresBelowMin.inputLabel',
			min
		))
		this.$('.allow-scores-outside-max .label-text').text(i18n.get(
			'admin.appConfiguration.scoring.allowScoresAboveMax.inputLabel',
			max
		))
	},

	_getFormattedMinMaxScores: function() {
		const dataType = this.showScoresAsToggle.val()
		const formatToShowAs = value => formatValue({ value, dataType })
		const showAsPercent = this._getShowScoresAsPercent()

		let min = this.$('[name=minimumScore]').val()
		let max = this.$('[name=maximumScore]').val()
		if (showAsPercent) {
			min = 0
			max = 1
		}

		return [ min, max ]
			.map(formatToShowAs)
	},

	_getShowScoresAsPercent: function() {
		return this.showScoresAsToggle.val() === PERCENT
	},

	_addScoreMinMaxRangeValidators: function() {
		const addValidator = (name, validator) =>
			this._findMarkedFieldByInputName(name).options.validators.push(validator)
		const getSanitized = name => {
			const val = this.$(`[name=${name}]`).val()
			const safeVal = (val || '').trim()
			return safeVal && parseFloat(val)
		}

		addValidator('maximumScore', numericRangeValidatorFactory(
			() => getSanitized('minimumScore'),
			null,
			null,
			{ excludeLow: true }
		))

		addValidator('minimumScore', numericRangeValidatorFactory(
			null,
			() => getSanitized('maximumScore'),
			null,
			{ excludeHigh: true }
		))
	},

	/**
	 * Updates the marked field options for score fields
	 * (redMetricIndicatorScore, requireNoteScore)
	 * Also adjusts the values based on the current selection of
	 * "Show Scores As" if needed (ex. when not cancelling)
	 * @param {Boolean} cancel - if updating scoring fields after cancelling
	 */
	_updateScoreFields: function(cancel) {
		_.each(this.$('input.score[type=text]'), input => {
			this.markScoreField(input)
			if (cancel) {
				// when cancelling, re-render the marked field so we have
				// correct formatting
				let markedField = this._findMarkedFieldByInputName(input.name)
				markedField.render()
			} else {
				// if not cancelling, adjust the values
				this._adjustScoreFieldValue(input)
			}
		})
	},

	/**
	 * Adjusts the value of the given input based on the current selection of
	 * "Show Scores As" toggle
	 */
	_adjustScoreFieldValue: function(input) {
		let currentVal = this.$(input).val()
		let adjustedVal
		if (this._getShowScoresAsPercent()) {
			adjustedVal = scoreToPercent(currentVal)
		} else {
			adjustedVal = percentToScore(currentVal)
		}
		this.$(input).val(adjustedVal)
	},

	_onChangeOidcLookupUserBy: function() {
		const choice = this.$('[name=oidcLookupUserBy]').val()
		const val = choice === 'username' ? 'preferred_name' : choice
		this.$('input[name=oidcClaimProperty]').val(val)
	},

	_onAuthTypeChange: function () {
		this._updateAuthSectionVisibility()
		this._updatePasswordSettingsVisibility()
	},

	_updateAuthSectionVisibility: function () {
		const type = this.authType()
		this.$('.authentication')
			.toggleClass('ldap-displayed', type == 'ldap')
			.toggleClass('openid-displayed', type == 'open-id')
			.toggleClass('saml-displayed', type == 'saml')

		const cms = this.$('select[name=passwordReuseInterval],' +
			'input[name=forcePasswordChangeDays],' +
			'select[name=maxInvalidLoginAttempts],' +
			'select[name=allowPasswordReset]')
			.closest('label')

		cms.toggleClass('is-not-displayed', type != 'cms')
	},


	updateCertSendWithRESTImportsVisibility: function() {
		this._updateCertSendWithRESTImportsVisibility(APP_CERTIFICATE_PEM)
		this._updateCertSendWithRESTImportsVisibility(APP_CERTIFICATE_PRIVATE_KEY_PEM)
	},

	_updateCertSendWithRESTImportsVisibility: function(configKey) {
		// user hasn't entered the PEM file yet
		if (_.isNil(this.config[configKey])) {
			// remove the uploaded cert component
			const className	= this.getCertUploadedRootElClassName(configKey)
			this.$(`.${className} .file-attachment`).remove()

			const configKeyTextarea$ = this.$(`[name=${configKey}]`)
			configKeyTextarea$.removeClass('is-not-displayed')

			// create a marked field so we can have validation for the PEM file they paste in
			const markedField = this._findMarkedFieldByInputName(configKey)
			if (_.isNil(markedField)) {
				this._markedFields.push(new MarkedField({
					el: configKeyTextarea$,
					validator: pemFileValidator
				}).render())
			}

			return
		}

		// PEM file has been entered and saved
		this.$(`[name=${configKey}]`).addClass('is-not-displayed')
		this._renderUploadedCert(configKey)
	},

	getCertConfigValueLabel: function(configKey) {
		return i18n.get(`admin.certSendWithRESTImports.${configKey}`)
	},

	getCertUploadedRootElClassName: function(configKey) {
		return configKey === APP_CERTIFICATE_PEM ? 'app-cert' : 'app-cert-private-key'
	},

	getCertUploadedDeleteButtonClassName: function(configKey) {
		return `${this.getCertUploadedRootElClassName(configKey)}-uploaded-reset`
	},

	_renderUploadedCert(configKey) {
		const className	= this.getCertUploadedRootElClassName(configKey)
		const rootEl$ = this.$(`.${className}`)
		this.$(`.${className} .file-attachment`).remove()
		const fileAttachmentOptions = this._getFileAttachmentOptionsForCertSection(configKey)

		rootEl$.append(fileAttachment())
			.find('.file-attachment-content')
			.append(
				$(fileAttachmentContent(fileAttachmentOptions))
					.addClass('file-uploader-view-uploading')
			)
		rootEl$.find('.reset')
			.addClass(this.getCertUploadedDeleteButtonClassName(configKey))
	},

	_getFileAttachmentOptionsForCertSection: function(configKey) {
		const label = i18n.get('admin.certSendWithRESTImports.uploaded',
			this.getCertConfigValueLabel(configKey))
		if (configKey === APP_CERTIFICATE_PEM) {
			return {
				class: 'app-cert-uploaded-details',
				detailIcon: 'diagnostic-license',
				label,
			}
		}
		if (configKey === APP_CERTIFICATE_PRIVATE_KEY_PEM) {
			return {
				class: 'app-cert-private-key-uploaded-details',
				detailIcon: 'primary-key',
				label,
			}
		}

		throw new Error(`Unexpected configKey: ${configKey}`)
	},

	onResetAppCert: function() {
		this._onUploadedCertReset(APP_CERTIFICATE_PEM)
	},

	onResetAppCertPrivateKey: function() {
		this._onUploadedCertReset(APP_CERTIFICATE_PRIVATE_KEY_PEM)
	},

	_onUploadedCertReset: function(configKey) {
		this.config[configKey] = null
		this.$(`[name=${configKey}]`).val(null)
		this._updateCertSendWithRESTImportsVisibility(configKey)
		this.formView.setDirty()
	},

	// #24730 hide password setting when windows auth is selected
	_updatePasswordSettingsVisibility: function () {
		if (this.authType() == 'cms') {
			this.$('.password-setting').removeClass('is-not-displayed')
			if (this.config.sms) { // re-hide allowPasswordReset for sms
				this.$('select[name=allowPasswordReset]')
					.closest('label')
					.addClass('is-not-displayed')
			}
		} else { // open-id, ldap, windows domain
			this.$('.password-setting').addClass('is-not-displayed')
		}

		// #49040 need this option for both standard and SAML authentication
		this.$('.disable-inactive-account-days').toggleClass('is-not-displayed',
			!_.includes(['cms', 'saml'], this.authType()))
	},

	authType: function () {
		return this.$('[name=authenticationType]').val()
	},

	// render defaultCurrencyCode dropdown
	renderCurrencies: function () {
		var $el = this.$('[name=defaultCurrencyCode]').empty()
		dropdown.currency($el, this.config.defaultCurrencyCode, {omitDefault: true})
	},

	renderReplicationFileStorageTypeSelects: function() {
		const createToggleOption = (item, type) =>
			_.extend({}, item, {
				value: item.id,
				label: item.id == 'no-replication' ? item.label : `${item.label}.${type}`
			})

		let replicationFileStorageTypesTo =
			_.map(enums.toOptionData('replicationFileStorageType'),
				item => createToggleOption(item, 'to'))
		_.forEach(replicationFileStorageTypesTo, i => {
			let option = new Option(i18n.get(i.label), i.id)
			this.$('.replication-write-type').append(option)
		})

		let replicationFileStorageTypesFrom =
			_.map(enums.toOptionData('replicationFileStorageType'),
				item => createToggleOption(item, 'from'))

		_.forEach(replicationFileStorageTypesFrom, i => {
			let option = new Option(i18n.get(i.label), i.id)
			this.$('.replication-read-type').append(option)
		})

		this.replicationWriteTypeSelect = this.$('.replication-write-type')
		this.replicationReadTypeSelect = this.$('.replication-read-type')

		this.replicationWriteTypeSelect.on('change', () =>
			this.onChangeReplicationFileStorageTypeSelects())
		this.replicationReadTypeSelect.on('change', () =>
			this.onChangeReplicationFileStorageTypeSelects())
	},

	renderReplicationEditableButtons: function() {
		this.setOrganizationButton = new EditableButton({
			el: this.$('.set-organization'),
			extraClasses: 'set-organization',
			message: 'common.replication.setOrganization'
		}).render()
		const orgLabel = _.get(this.config, 'replicationWriteOrganization.label')
		!_.isNil(orgLabel) && this.setOrganizationButton.renderLabel(orgLabel)

		this.setFileButton = new EditableButton({
			el: this.$('.set-file'),
			extraClasses: 'set-file',
			message: 'common.replication.setFile'
		}).render()
		const fileLabel = _.get(this.config, 'replicationReadFile.label')
		!_.isNil(fileLabel) && this.setFileButton.renderLabel(fileLabel)
	},

	renderReplicationDestinationForm: function(e) {
		let isSetFile = this.$(e.target).hasClass('set-file')
		let button = isSetFile ?
			this.setFileButton : this.setOrganizationButton

		let section = isSetFile ? 'files' : 'organizations'
		let currentSelection = isSetFile ? this.config.replicationReadFile :
			this.config.replicationWriteOrganization

		this.orgSelectionForm = new OrgSelectionForm(_.extend({},{
			section,
			id: _.isNil(currentSelection) ? null : currentSelection.id,
			projectId: _.isNil(currentSelection) ? null : currentSelection.projectId,
			enableProjects: this.config.enableProjects
		}, currentSelection))
		appDisplay.dialog(this.orgSelectionForm)

		this.orgSelectionForm.on('selected', selected => {
			this.orgSelectionForm.trigger('done') // hide the dialog
			this.formView.change()
			let newData = isSetFile ? { replicationReadFileId: selected.id } :
				{ replicationWriteOrganizationId: selected.id}
			this.replicationSettings = _.extend({},
				this.replicationSettings, newData)
			button.renderLabel(selected.label)
		})
	},

	onChangeReplicationFileStorageTypeSelects: function(e) {
		if (e) {
			// #45088 Only flag the form as dirty if this was called from a
			// change event
			this.formView.change()
		}
		let replicationWriteTypeVal = this.replicationWriteTypeSelect.val()
		let replicationReadTypeVal = this.replicationReadTypeSelect.val()

		this.$('.replication-path, .replication-archive-dir, .replication-datasinks')
			.toggleClass('is-not-displayed', replicationWriteTypeVal !== 'local-file-system')

		this.$('.replication-org-select')
			.toggleClass('is-not-displayed', replicationWriteTypeVal !== 'documents-section')

		this.$('.replication-read-dir')
			.toggleClass('is-not-displayed', replicationReadTypeVal === 'no-replication')

		this.$('.replication-file-select')
			.toggleClass('is-not-displayed', replicationReadTypeVal !== 'documents-section')
	},

	_renderTagChoosers: function() {
		this._removeTagChoosers()
		const configsToPlaceholders = {
			'titles': 'userTitles',
			'units': 'metricUnits',
			'tags': 'allowedTags'
		}

		this.tagChoosers = _.map(_.keys(configsToPlaceholders), conf => {
			let globalTags = null
			// #57889
			// Do not populate the globally saved tags if we're not
			// rendering the "tags" TagsChooser
			if (conf === 'tags') {
				globalTags = this?.globalTags
			}
			return new TagsChooser({
				el: this.$(`[name=${conf}]`),
				tags: _.get(this.config, conf) || [],
				checkAllowedTags: false,
				selectOptions: {
					placeholder: i18n.get(`admin.appConfiguration.generalSettings.${configsToPlaceholders[conf]}.placeholder`)
				},
				globalTags
			}).render()
		})
	},

	_renderMetricUpdateReminders: function () {
		let selections = _.get(this.config, 'alertDaysOverdueMetrics', [])
		var options = []
		// -90,-60,-30,-15......15,30,60,90 with 0 omitted
		var days = [-90,-60,-30].concat(_.range(-15, 0)).concat(_.range(1,16)).concat([30,60,90])

		_.each(days, function (day) {
			var code = 'admin.appConfiguration.emailNotification.daysOverdue.' +
					   (day < 0 ? 'daysBefore' : 'daysAfter')
			var label = i18n.get(code, Math.abs(day))
			options.push({
				label: label,
				value: day,
				selected: _.includes(selections, day)
			})
		})
		var selectOpts = {
			options: options,
			multiple: true
		}
		selects(this.$('[name=alertDaysOverdueMetrics]'), selectOpts)
	},

	// populate the form with the correct values from the config
	writeToDom: function() {
		var values = _.clone(this.config)

		// #59800 remove changes for #43370 (added formatting for numeric
		// fields that might be using decimals ie, redMetricIndicatorScore, requireNoteScore)
		// #59140 fixed this issue by writing the values to the DOM before
		// the marked fields are created, and prevents complications with those
		// fields when we are in a RTL language and scores are formatted as percent

		this.showScoresAsToggle
			.val(this.config.showScoresAsPercent ? PERCENT : NUMBER, {
				silent: true
			})

		formHelper.writeToDom(values, this.el)

		this._renderMetricUpdateReminders()
		this._renderTagChoosers()
	},

	// secure the display by hiding stuff the user doesn't have permission to view
	secure: function() {
		// hide fields if modifying scorecards is not allowed by license
		if (!license.scorecards) {
			this.$('.license-scorecards').addClass('is-not-displayed')
		}

		// replication settings
		if (!this.config.replicationEnabled) {
			this.$('.replication').addClass('is-not-displayed')
		}

		if (!this.config.replicationDeactivated) {
			this.$('input[name=replicationSequence]')
				.closest('label')
				.addClass('is-not-displayed')
		}
		// sms-specific display - hide allowPasswordReset
		if (this.config.sms) {
			this.$('select[name=allowPasswordReset]')
				.closest('label')
				.addClass('is-not-displayed')
		}
	},

	_readScoreMinMaxAndDisplayAs: function(config) {
		// convert showScoresAs toggle value to persisted form
		const showAsWasSet = !_.isNil(this.config.showScoresAsPercent)
		const showAsPercent = this._getShowScoresAsPercent()
		const showAsHasChanged = showAsPercent || (showAsWasSet && !showAsPercent)
		if (showAsHasChanged) {
			config.showScoresAsPercent = showAsPercent
		}
		if (showAsPercent) {
			config.minimumScore = 0
			config.maximumScore = 1
		}

		delete config.showScoresAs
	},

	/**
	 * Returns true if any of the changes made will trigger a score recalc
	 */
	changesTriggerScoreRecalculation: function() {
		let recalcProperties = [
			'showScoresAsPercent', //Show Scores As
			'minimumScore', 'maximumScore', //Minimum/Maximum Score
			'allowScoresBelowMin', 'allowScoresAboveMax', //Allow Scores to Extend Beyond X
			'ignoreGrayScoresInRollups', //Ignore Gray Scorecard Items For Tree Rollup
			'ignorePeriodsWithoutValues', //Ignore Periods Without Values For Time Aggregation
			'forwardEffectScoring', //Enable Forward Effect Scoring
			'divideByZeroEqualsZero', //Divide By Zero Equals Zero
			'nonMetricScoringTypeId' //Scoring Type For Non-KPIs
		]

		let prevConfig = _.pick(this._lastSavedData.config, recalcProperties)
		// #47574 remove any null values to prevent a false recalc prompt
		// if we have property that looks like '"showScoresAsPercent": null'
		prevConfig = _.omitBy(prevConfig, _.isNil)

		let currentConfig = _.pick(formHelper.readFromDom(this.el), recalcProperties)
		// populate the  showScoresAsPercent property for current config
		this._readScoreMinMaxAndDisplayAs(currentConfig)
		_.each(currentConfig, function(value, key) {
			// so we aren't trying to compare booleans to strings
			currentConfig[key] = JSON.parse(value)
		})
		return !_.isEqual(prevConfig, currentConfig)
	},

	test: function() {
		let data = this.getSubmitData()

		let err = AdminApp.testDisallowingScoresAboveBelowMinMax({
			scoringTypes: config.scoringTypes,
			newMinimumScore: data.config.minimumScore,
			newMaximumScore: data.config.maximumScore,
			oldAllowScoresBelowMin: config.allowScoresBelowMin,
			newAllowScoresBelowMin: data.config.allowScoresBelowMin == 'true',
			oldAllowScoresAboveMax: config.allowScoresAboveMax,
			newAllowScoresAboveMax: data.config.allowScoresAboveMax == 'true'
		})

		return i18n.get(err) || FormView.prototype.test.apply(this, arguments)
	},

	testAppCertAndAppCertPrivateKey: function() {
		return _.filter([
			this._requireAppCertAndAppCertPrivateKey(APP_CERTIFICATE_PEM),
			this._requireAppCertAndAppCertPrivateKey(APP_CERTIFICATE_PRIVATE_KEY_PEM)
		], err => !_.isNil(err))
	},

	/**
	 * If we have the {@link APP_CERTIFICATE_PEM} and not the {@link APP_CERTIFICATE_PRIVATE_KEY_PEM}, or
	 * vice versa, we need to require the user to enter both.
	 */
	_requireAppCertAndAppCertPrivateKey: function(configKey) {
		const valueFromDom = this.$(`[name=${configKey}]`).val()
		let value = valueFromDom
		// if a value has been saved before. it won't be in the DOM
		if (_.isEmpty(value) && !_.isNil(this.options.config[configKey])) {
			value = this.config[configKey]
		}
		// if the value is null, undefined, or empty, we don't need the
		// cert or private key specified either
		if (_.isNil(value) || _.isEmpty(value)) return

		const oppositeConfigKey =
			this.getOppositeConfigKeyForAppCertSendWithRESTImports(configKey)
		const oppositeConfigVal = this.$(`[name=${oppositeConfigKey}]`).val()
		if (_.isNil(oppositeConfigVal) || _.isEmpty(oppositeConfigVal)) {
			const errorMessage = i18n.get('admin.certSendWithRESTImports.error.bothRequired',
				this.getCertConfigValueLabel(oppositeConfigKey),
				this.getCertConfigValueLabel(configKey))
			const oppositeConfigMarkedField =
				this._findMarkedFieldByInputName(oppositeConfigKey)
			oppositeConfigMarkedField.error(errorMessage)
			return errorMessage
		}
	},

	getOppositeConfigKeyForAppCertSendWithRESTImports: function(configKey) {
		return configKey === APP_CERTIFICATE_PEM ?
			APP_CERTIFICATE_PRIVATE_KEY_PEM : APP_CERTIFICATE_PEM
	},

	submit: function(e) {
		const appCertErrors = this.testAppCertAndAppCertPrivateKey()
		if (!_.isEmpty(appCertErrors)) {
			this.formView.start()
			return
		}

		// #44189 Warn when a settings change will trigger a full score calc
		if (this.changesTriggerScoreRecalculation()) {
			let recalcPrompt = new ConfirmPrompt({
				titleKey: 'admin.recalcScores',
				messageKey: 'admin.recalcScoresConfirm',
				confirmLabel: 'admin.recalcScores.recalculate',
				cancelLabel: 'common.cancel',
				onConfirm: () => {
					this._submitWithLogoCheck()
				}
			})
			recalcPrompt.once('cancel', () => this.cancel())
			appDisplay.dialog(recalcPrompt)
		} else {
			this._submitWithLogoCheck()
		}
	},

	_submitWithLogoCheck: function() {
		let data = this.getSubmitData()
		if (this.localConfig.customLogoId != this.config.customLogoId) {
			data.config.customLogoId = this.localConfig.customLogoId
		}
		this._submit(data)
	},

	getSubmitData: function() {
		var formData = formHelper.readFromDom(this.el)
		var configData = _.extend(formData, this.replicationSettings, {
			customLogoId: this.getCurrentLogoId(),
			scorecardsChartStartPeriodDelta: this.calendarRangeSelector.val().first,
			scorecardsChartEndPeriodDelta: this.calendarRangeSelector.val().last
		})

		const referToByLanguage = this._readReferToByLanguage(configData)
		this._readScoreMinMaxAndDisplayAs(configData)

		const configHash = _.omitBy(configData, (v,k) => _.startsWith(k,'oidc'))
		const oidcConfig = _.pickBy(configData, (v,k) => _.startsWith(k,'oidc'))

		return {
			ldapServers: this.ldapServers.toJSON(),
			referToByLanguage,
			config: configHash,
			openIdConnectionParameters: _.isEmpty(oidcConfig) ? undefined : oidcConfig
		}
	},

	_readReferToByLanguage (configData) {
		let referToByLanguage = {}
		this.$('[name^=referTo]').each((index, el) => {
			let input = $(el)
			let key = input.attr('name')
			let value = input.val()

			let [simpleKey, language] = key.split('.')
			let referToForLanguage = referToByLanguage[language]
			if (!referToForLanguage) {
				referToForLanguage = referToByLanguage[language] = {}
			}
			referToForLanguage[simpleKey] = value

			configData[key] = undefined
		})

		configData.language = undefined

		return referToByLanguage
	},

	getCurrentLogoId: function() {
		return this.localConfig.customLogoId ?? null
	},

	_submit: function() {
		let data = this.getSubmitData()
		return $.ajax({
			method: 'post',
			url: 'api/admin/app',
			data: JSON.stringify(data),
			success: function(result) {
				config.update(result.config)
				this.config = result.config
				if (this.localConfig.customLogoId === null &&
					this._lastSavedData.config.customLogoId != null) {
					this.deleteSavedLogo(this._lastSavedData.config.customLogoId)
				}
				this.localConfig.customLogoId = result.config.customLogoId
				this.config.showScoresAs = result.config.showScoresAsPercent ?
					PERCENT : NUMBER
				config.customLogoId = this.localConfig.customLogoId

				let terminologyChanged = !_.isEqual(
					this._lastSavedData.referToByLanguage,
					result.referToByLanguage)

				const displayStrategyMapsChanged =
					this._lastSavedData.config.displayStrategyMaps !== this.config.displayStrategyMaps
				let customLogoChanged =
					this._lastSavedData.config.customLogoId !== this.config.customLogoId
				if (terminologyChanged || displayStrategyMapsChanged || customLogoChanged) {
					//if we're changing methodology, refresh the browser so the current
					//user sees the change in terminology
					location.reload()
				} else {
					this.ldapServers.set(_.map(result.ldapServers, function (server) {
						// make sure message and stackTrace default to null, or Backbone
						// won't clear them if the server response doesn't have an error
						return _.extend({ message: null, stackTrace: null }, server)
					}))

					if (this._lastSavedData.config.enableProjects !== this.config.enableProjects) {
						Backbone.trigger('config:enableProjects')
					}

					this._lastSavedData = result

					this.updateCertSendWithRESTImportsVisibility()

					this.formView.start()
				}
			}.bind(this),
			error: function(xhr) {
				// if validation failed and we have specific field-level errors
				if (xhr.responseJSON && xhr.responseJSON.errors) {
					_.forEach(xhr.responseJSON.errors, function (err) {
						var el = this.$('[name=' + err.field + ']')
						// the replicationDatasinks field isn't normally marked
						// but can become marked if an error happens
						var view = el.data('view')
						if (!view) {
							view = new MarkedField({ el: el }).render()
							this._markedFields.push(view)
						}
						// Clear message to allow latest error to show
						view.message = null
						view.error(err.message, true)
					}.bind(this))
					this.$('.cancel').attr('disabled', false)
					this.formView.primaryButton.disable()
					// #43370 allow user to fix field-level errors from the
					// server;  remove the faded out appearance after getting
					this.formView._setSubmitting(false)
				} else { // some random blowup happened
					this.formView.error(xhr)
				}
			}.bind(this)
		})
	},

	cancel: function () {
		// Revert the configuration to the last saved state
		this.config = this._lastSavedData.config

		// Reset all form fields to the last saved state
		this.writeToDom()

		const currentLogoId = this.unsavedLogoId
		const savedLogoId = this._lastSavedData.config.customLogoId

		// Check if the logo has changed
		if (currentLogoId !== savedLogoId) {
			// If we added a new logo but didn't save, delete it
			if (currentLogoId && currentLogoId !== savedLogoId) {
				this.deleteUnsavedLogo(currentLogoId)
			}
			// Revert to the previously saved logo (which might be null for default)
			this.unsavedLogoId = null
			this.localConfig.customLogoId = savedLogoId
			this.renderImpactIcon()
			this.renderDeleteLogoButton()
		}

		this.updateMinimumAndMaximumMarkedFieldsAfterCancel()
		// #49674 make sure display of minimum and maximum scores is correct
		this.toggleMinMaxScore()
		// #49720 make sure score type fields are marked correctly
		this._updateScoreFields(true)

		this._updateAuthSectionVisibility()
		this.ldapServers.set(this._lastSavedData.ldapServers)
		this.renderPublicReadOnlyUserIdChooser()
		this.renderAuthenticationSelects()
		// #49673 update this.selectedAlertUsers from last saved data
		this.selectedAlertUsers = this._lastSavedData.accountChangeAlertUsers
		this._renderPrincipalChooser()

		// #55635 re-populate the app certificate and private key fields
		this._cancelCertSendWithRESTImports()

    	// Need to use process.nextTick() as renderAuthenticationSelects can
    	// cause change events and dirty the form
		process.nextTick(() => this.formView.start())
	},

	_cancelCertSendWithRESTImports: function() {
		this.config[APP_CERTIFICATE_PEM] =
			this.options.config[APP_CERTIFICATE_PEM]
		this.config[APP_CERTIFICATE_PRIVATE_KEY_PEM] =
			this.options.config[APP_CERTIFICATE_PRIVATE_KEY_PEM]
		this.updateCertSendWithRESTImportsVisibility()
	},

	/**
	 * If the form was cancelled after toggling from "Show Scores As" from
	 * percent to number, the '%' sign can linger as marker content for
	 * minimum and maximum score fields.
	 * This clears out the unwanted marker content.
	 */
	updateMinimumAndMaximumMarkedFieldsAfterCancel: function() {
		let dataType = this.showScoresAsToggle.val()
		if (dataType === NUMBER) {
			_.each(['minimumScore', 'maximumScore'], inputName => {
				let markedField = this._findMarkedFieldByInputName(inputName)
				if (!_.isNil(markedField)) {
					let opts = _.clone(markedField.options)
					// if the form has "Show scores as" number, but the marked
					// field still has 'percent' as a dataType, update it
					if (opts.dataType != NUMBER) {
						opts.dataType = NUMBER
						markedField.mark(opts)
						markedField.updateMarkerContent()
					}
				}
			})
		}
	},

	currencies: function() {
		appDisplay.dialog($.get('api/admin/app/currencies'), function(data) {
			var view = new AdminCurrencies({ data: data })
			view.on('done', function() {
				this.config.defaultCurrencyCode = config.defaultCurrencyCode
				this.renderCurrencies()
			}.bind(this))
			return view
		}.bind(this))
	},

	_removeTagChoosers: function() {
		_.invokeMap(this.tagChoosers, 'remove')
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.formView, this._ldapServersView,
			this.publicReadOnlyUserIdChooser, this.principalChooser,
			this.replicationReadTypeSelect, this.replicationWriteTypeSelect,
			this.showScoresAsToggle],
			'remove')
		_.invokeMap(this._markedFields, 'remove')
		this._removeTagChoosers()
		potentialPrincipals = null
		this.fileDropOverlay?.remove()
		this.calendarRangeSelector.remove()
	}

}, {

	/**
	 * Prevents disallowing scores below min or above max when there are
	 * scoring types defined that have scores that are already below the
	 * minimum or above the maximum.
	 *
	 * @return {string} any error found
	 */
	testDisallowingScoresAboveBelowMinMax: function({
		scoringTypes,
		newMinimumScore,
		newMaximumScore,
		oldAllowScoresBelowMin,
		newAllowScoresBelowMin,
		oldAllowScoresAboveMax,
		newAllowScoresAboveMax,
	}) {
		// prevent disallowing scores below min when there are scoring types
		// defined that have scores that are already below the minimum
		if (oldAllowScoresBelowMin && !newAllowScoresBelowMin) {
			let problemScoringType = _.find(scoringTypes, (scoringType) => {
				// ignore standard scoring types
				if (scoringType.standardScoringType) return
				let firstThreshold = _.first(scoringType.thresholds)
				return firstThreshold && firstThreshold.score < newMinimumScore
			})
			if (problemScoringType) {
				let problemScoringTypeLabel = highlight(problemScoringType.label)
				let newMinScoreFormatted = formatValue({
					value: newMinimumScore,
					dataType: SCORE
				})
				return i18n.get(
					'scorecards.node.metric.allowScoresBelowMin.impossible',
					newMinScoreFormatted, problemScoringTypeLabel)
			}
		}

		// prevent disallowing scores above max when there are scoring types
		// defined that have scores that are already above the maximum
		if (oldAllowScoresAboveMax && !newAllowScoresAboveMax) {
			let problemScoringType = _.find(scoringTypes, (scoringType) => {
				// ignore standard scoring types
				if (scoringType.standardScoringType) return
				let lastThreshold = _.last(scoringType.thresholds)
				return lastThreshold && lastThreshold.score > newMaximumScore
			})
			if (problemScoringType) {
				let problemScoringTypeLabel = highlight(problemScoringType.label)
				let newMaxScoreFormatted = formatValue({
					value: newMaximumScore,
					dataType: SCORE
				})
				return i18n.get(
					'scorecards.node.metric.allowScoresBelowMax.impossible',
					newMaxScoreFormatted, problemScoringTypeLabel)
			}
		}
	}

})

const METHODOLOGY_OBJECT_TYPES = [
	'perspective', 'objective', 'genericItem', 'kpi', 'initiative',
	'task', 'milestone']

const METHODOLOGY_ICON_OVERRIDES = {
	kpi: 'metric',
	genericItem: 'generic'
}

export default AdminApp
export { getAllowedNonMetricScoringTypes }

AdminApp.__filename__ = 'admin/configuration/admin-app.js'
